import './pageLoader.css'

const PageLoader = () => {
  return (
    <div className="lds-ripple"><div></div><div></div></div>
  )
}

export default PageLoader